import { supabase } from "./supabase.js";

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message);
  }
}

// Si VITE_API_URL est fourni (déploiement cross-domain), on l'utilise comme
// préfixe absolu. Sinon, chemin relatif → proxy Vite en dev, même origine en
// prod. Strip d'un trailing slash pour éviter `//api/v1`.
const API_BASE = (
  (import.meta.env.VITE_API_URL as string | undefined) ?? ""
).replace(/\/$/, "");

async function getToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const token = await getToken();
  const headers = new Headers(init.headers);
  headers.set("content-type", "application/json");
  if (token) headers.set("authorization", `Bearer ${token}`);

  const r = await fetch(`${API_BASE}/api/v1${path}`, { ...init, headers });
  const text = await r.text();
  const body = text ? JSON.parse(text) : null;
  if (!r.ok) {
    throw new ApiError(
      r.status,
      body?.code ?? "http_error",
      body?.message ?? `http ${r.status}`,
    );
  }
  return body as T;
}
